<template>
  <table v-if="topline.length > 0">
    <tr>
      <th style="width: 10px;"></th>
      <th style="text-align: left;">Party</th>
      <th style="text-align: right;">Vote %</th>
      <th style="width: 120px; text-align: right;">+/- Change</th>
    </tr>
    <results-table-row
      v-for="(party, index) in parties"
      :key="index"
      :item="topline.find(t => t.party === party.match)"
      :party="party">
    </results-table-row>
  </table>
</template>

<script>
import { parties } from "@/config";

import ResultsTableRow from "./ResultsTableRow"

export default {
  props: {
    topline: {
      type: Array,
      required: true
    },
  },
  components: {
    ResultsTableRow
  },
  data: () => ({
    parties
  })
};
</script>

<style>
table {
  width: 100%;
}

th {
  font-size: 13px;
  font-weight: 600;
  color: #666666;
  border-bottom: 1px solid #666666;
}

tr {
  height: 42px;
  border-bottom: 0.5px solid #eeeeee;
}

td {
  font-weight: 500;
}

.map-key-rect {
  height: 42px;
  width: 10px;
  margin-bottom: 0px;
}

.results-table-row-background {
  height: 100%;
  opacity: 0.2;
  position: absolute;
  left: 10px;
  top: 0px;
}

.party {
  padding-left: 10px;
}

.vote-perc,
.change {
  text-align: right;
}

.change-chip {
  min-width: 42px;
  display: flex;
  float: right;
  border-radius: 8px;
  font-size: 13px;
  height: 24px;
  align-items: center;
  justify-content: center;
  color: black;
}
</style>
